export function fixNameEnum(str?: string | null): string {
  return !str
    ? '-'
    : `${String(str).charAt(0).toUpperCase() + String(str).slice(1).toLowerCase()}`
        .replace(/_/g, ' ')
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
}

export function camelCaseToHumanReadable(camelCaseStr?: string): string {
  const result = camelCaseStr?.replace(/([A-Z])/g, ' $1').replace(/^./, function (str) {
    return str.toUpperCase();
  });
  return result?.trim() || '-';
}

export function isUpperCase(char: string): boolean {
  return char === char.toUpperCase() && char !== char.toLowerCase();
}
